import { FC } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { Role } from 'src/store/models/Auth';

import ManufacturerTicketDetails from './ManufacturerTicketDetails/ManufacturerTicketDetails';
import ServiceTicketDetails from './ServiceTicketDetails/ServiceTicketDetails';

const TicketDetails: FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  return user?.role === Role.SERVICE ? (
    <ServiceTicketDetails />
  ) : user?.role === Role.MANUFACTURER ? (
    <ManufacturerTicketDetails />
  ) : (
    <>Ticket details</>
  );
};

export default TicketDetails;
